export default {
  text: 'white',
  primary: '#202020',
  secondary: '#fdbe38',
  background: 'black',
  backgroundSecondary: '#e3e3db',
  light: '#fdfdfd',
  dark: '#202020'
}
